



















import VacancyRespondForm from '@/pages/vacancies/form';
import FinishMessage from '@/components/parts/catalog/card/components/request/components/finishMessage/FinishMessage.vue';
import AppSteppers from '@/uikit/components/AppSteppers/AppSteppers.vue';
import AppSteppersPane from '@/uikit/components/AppSteppers/components/AppSteppersPane.vue';
import DynamicAdditionalDataForm from '@/components/ordersProcessForms/parts/AdditionalDataStep/DynamicAdditionalDataForm.vue';
import { vacanciesService } from '@/services';
import { FETCH_ITEM, STORE_MODULE_NAME } from '@/pages/vacancies/card/consts';
import { mapActions } from 'vuex';
const actions = mapActions(STORE_MODULE_NAME, [FETCH_ITEM]);
const fetch = actions[FETCH_ITEM];
export default {
  name: 'VacancyRespondFormBody',
  components: {
    DynamicAdditionalDataForm,
    AppSteppersPane,
    AppSteppers,
    FinishMessage,
    VacancyRespondForm,
  },
  data() {
    return {
      id: this.$store.state.vacancy.vacancy.id,
      message: {
        type: 'success',
        text: {
          description:
            'Спасибо, что откликнулись на вакансию. Ваш отклик будет обработан в ближайшее время. На вашу электронную почту будет направлено письмо от организации-работодателя. Уточнить статус отклика вы сможете в своем личном кабинете.',
          title: '',
          warning: '',
        },
      },
      isLoading: false,
      isError: false,
      errorMessage: '',
      isMessage: false,
    };
  },
  inject: ['$api'],
  methods: {
    closeForm() {
      this.isMessage = false;
      this.isError = false;
      this.errorMessage = '';
      this.isLoading = false;
      this.$ui.$modal.close('VacancyRespondFormBody');
    },
    async submitRespond(next: Function, data: any) {
      if (!this.id) return;
      const result = {
        vacancy_id: this.id,
        cover_letter: data!.text || '',
        resume_file: data.files.name.length ? data.files : '',
      };

      this.isLoading = true;

      try {
        const res = await vacanciesService(this.$api).postVacancyFeedback(
          result
        );
        const context = { $store: this.$store };
        const params = {
          ...this.$route.query,
          ...this.$route.params,
        };
        await fetch.call(context, params.id);
        this.isMessage = true;
        this.isLoading = false;
        next();
      } catch (err) {
        const [{ msg }] = err.response.data.errors;

        if (msg) this.errorMessage = msg;
        this.isMessage = true;
        this.isError = true;
        this.isLoading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/vacancy/VacancyRespondFormModalBody.vue